import React, { Component } from "react";

/*
PROPS
- data
- borderStyle
- isEditing
*/

class Button extends Component {
  render() {
    let href = this.props.isEditing ? "javascript:;" : this.props.data.url
    return (
      <a
        style={{
          ...this.props.data.style,
          ...this.props.borderStyle,
          // pointerEvents: this.props.isEditing ? "none" : "auto",
        }}
        href={href}
        // target="blank"
      >
        {this.props.data.value}
      </a>
    );
  }
}

export default Button;
